import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import makeStyles from '@mui/styles/makeStyles';
import Timeline from './Timeline';
import { sharedStyles } from '../../shared/styles';
import { useConsultSummaries, useEpisodeOfCareSummary } from '../../queries';



const DisabilityTimelineDialog = ({ open, onClose, episodeOfCareID}) => {
    const consultSummaryQuery = useConsultSummaries(episodeOfCareID??undefined);
    const episodeOfCareSummaryQuery = useEpisodeOfCareSummary(episodeOfCareID??undefined);
    const sharedClasses = sharedStyles();
    const classes = useStyles();
    const elementRef = React.useRef(null);
    React.useEffect(() => {
    if (open) {
    const { current: descriptionElement } = elementRef;
    if (descriptionElement !== null) {
    descriptionElement.focus();
    }
    }
    }, [open]);
    useEffect(() => {
        if (open) {
            consultSummaryQuery.refetch();
            episodeOfCareSummaryQuery.refetch();
        }
    }, [open]);

    return (
        <Dialog
            maxWidth={'md'}
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
            scroll={"paper"}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle>
                <div className={sharedClasses.heading} style={{fontSize: '2rem', margin: '0px'}}>
                    AI Incapacity/Disability Timeline
                </div>

                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent ref={elementRef}>
                <Timeline summaries={consultSummaryQuery.data??[]} mainSummary={episodeOfCareSummaryQuery.data??{}}/>
            </DialogContent>
        </Dialog>
    );
};

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minWidth: '40vw',
    },
}));

export default DisabilityTimelineDialog;
